import { addResizeListener, removeResizeListener } from 'yxt-biz-pc/src/utils/resize-event';

export default {
  data() {
    return {
      scrollHeight: 0
    };
  },
  mounted() {
    this.updateSize();
    addResizeListener(document.body, this.updateSize);
  },
  updated() {
    if (this.$refs.tree) {
      this.$refs.tree.querySelector('.yxt-scrollbar__wrap').style.height = this.$refs.tree.clientHeight - 16 + 'px';
    }
  },
  beforeDestroy() {
    removeResizeListener(document.body, this.updateSize);
  },
  methods: {
    updateSize() {
      if (this.$refs.table) {
        const rightFooterHeight = this.$refs.rightFooter ? this.$refs.rightFooter.clientHeight + 32 : 0;
        const rightHeaderHeight = this.$refs.rightHeader ? this.$refs.rightHeader.clientHeight : 0;
        const contHeight = this.$refs.rightCont.clientHeight - rightHeaderHeight - rightFooterHeight;
        const tableHeaderHeight = this.$refs.table.$el.querySelector('.yxt-table__header-wrapper').scrollHeight;
        const tableBodyHeight = this.$refs.table.$el.querySelector('.yxt-table__body-wrapper').scrollHeight;
        this.tableHeight = contHeight > tableHeaderHeight + tableBodyHeight ? tableBodyHeight + tableHeaderHeight : contHeight;
        this.$refs.table.doLayout();
      }
      if (this.$refs.tree) {
        this.$refs.tree.querySelector('.yxt-scrollbar__wrap').style.height = this.$refs.tree.clientHeight - 16 + 'px';
      }
    }
  }
};
